import { gql } from '@apollo/client';

export const FUNDER_SUBJECT_PASS_RATE = gql`
  query funderSubjectPassRate($input: FilterArgs) {
    funderSubjectPassRate(input: $input) {
      id
      name
      firstPassRate
      secondPassRate
      thirdPassRate
      fourthPassRate
    }
  }
`;
